exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1OtrSZdhKXVv3UhaivrdJ4{text-decoration:inherit;color:\"[theme:black, default:#000000]\"}html[dir] ._1OtrSZdhKXVv3UhaivrdJ4{border-radius:2px;padding:0 1px;background-color:\"[theme:neutralLighter, default:#f4f4f4]\"}html[dir] ._1OtrSZdhKXVv3UhaivrdJ4:hover{background-color:\"[theme:neutralLight, default:#eaeaea]\"}", ""]);
// Exports
exports.locals = {
	"mentionsCompose": "_1OtrSZdhKXVv3UhaivrdJ4"
};